/*eslint angular/file-name: 0*/
(function() {
    'use strict';
    angular
        .module('emarket.main', [
            'ui.router',
            'emarket.main.navigation',
            'emarket.main.province',
            'emarket.main.currency',
            'emarket.main.home',
            'emarket.main.plan',
            'emarket.main.category',
            'emarket.main.profile',
            'emarket.main.post',
            'emarket.main.favorite',
            'emarket.main.store',
            'emarket.main.statics',
            'emarket.main.customfield'
        ])
        .config(['$stateProvider', function($stateProvider) {
            $stateProvider.state('main', {
                abstract: true,
                views: {
                    app: {
                        templateUrl: 'main/main.tpl.html',
                        controller: 'MainController as model'
                    }
                }
            });
        }])
        .controller('MainController', ['$log', '$rootScope', '$scope', '$timeout', '$state', '$http', '$window', '$mdDialog', 'Announcer', 'ProvinceChooser', 'Chat', 'PATH', 'THEME', function(
            $log,
            $rootScope,
            $scope,
            $timeout,
            $state,
            $http,
            $window,
            $mdDialog,
            Announcer,
            ProvinceChooser,
            Chat,
            PATH,
            THEME
        ) {
            ContactDialogController.$inject = ['$scope', '$mdDialog', '$injector'];
            var announcer = Announcer.create($scope);

            $timeout(function() {
                announcer.emit(Announcer.types.CHANGE_THEME_COLOR, THEME.themeColor);
            });

            $rootScope.actions = {
                hideFabAction: false,
                hideFabActionMobile: false,
                hideNavigationMenu: false,
                transparentToolbar: false
            };
            var vm = this;
            announcer.on(Announcer.types.FULL_SCREEN_MODE, function(ev, mode) {
                vm.hideFooter = mode === false ? false : true;
            });
            vm.year = new Date().getFullYear();
            vm.timestamp = new Date().getTime();

            vm.openContactDialog = function openContactDialog() {
                $mdDialog.show({
                    controller: ContactDialogController,
                    templateUrl: 'main/contact-form.tpl.html',
                    clickOutsideToClose: false,
                });
            };

            $scope.$on('emarket.open-contact-dialog', vm.openContactDialog);

            var toggleStateAction = function(actions) {
                Object.keys($rootScope.actions).forEach(function(key) {
                    if (actions[key]) {
                        $rootScope.actions[key] = true;
                    } else {
                        $rootScope.actions[key] = false;
                    }
                });
            };
            var stateChangeAction = function(toState) {
                if (toState.data) {
                    toggleStateAction(toState.data);
                } else {
                    Object.keys($rootScope.actions).forEach(function(key) {
                        $rootScope.actions[key] = false;
                    });
                }
            };
            stateChangeAction($state.current);
            var event = $rootScope.$on('$stateChangeSuccess', function(event,
                toState) {
                if (toState.name !== 'main.post.search.detail') {
                    $window.scrollTo(0, 0);
                }
                stateChangeAction(toState);
                vm.hideFooter = false;
            });
            $scope.$on('$destroy', function() {
                event();
            });

            function ContactDialogController($scope, $mdDialog, $injector) {
                var $mdToast = $injector.get('$mdToast');
                $scope.form = {};

                $scope.cancel = function () {
                    $mdDialog.cancel();
                };

                $scope.send = function () {
                    grecaptcha.ready(function () {
                        grecaptcha.execute('6LesNpYaAAAAAB0hZGLrOQfoVH3wWPg4ytvos0MW', {
                            action: 'submit',
                        })
                        .then(function (token) {
                            $scope.form.token = token;
                            return $http.post(
                                PATH.api + '/contact',
                                $scope.form
                            );
                        })
                        .then(function (response) {
                            if (response && response.data && response.data.success) {
                                $mdDialog.hide();
                            } else {
                                var message = 'La información no pudo ser enviada, '
                                    + 'intenta más tarde o contacta con un administrador';
                                $mdToast.show(
                                    $mdToast
                                        .simple()
                                        .textContent(message)
                                        .hideDelay(5000)
                                );
                            }
                        });
                    });
                };
            }
        }]);
}());

/*eslint angular/file-name: 0*/
(function() {
    'use strict';
    angular
        .module('emarket.main', [
            'ui.router',
            'emarket.main.navigation',
            'emarket.main.province',
            'emarket.main.currency',
            'emarket.main.home',
            'emarket.main.plan',
            'emarket.main.category',
            'emarket.main.profile',
            'emarket.main.post',
            'emarket.main.favorite',
            'emarket.main.store',
            'emarket.main.statics',
            'emarket.main.customfield'
        ])
        .config(['$stateProvider', function($stateProvider) {
            $stateProvider.state('main', {
                abstract: true,
                views: {
                    app: {
                        templateUrl: 'main/main.tpl.html',
                        controller: 'MainController as model'
                    }
                }
            });
        }])
        .controller('MainController', ['$log', '$rootScope', '$scope', '$timeout', '$state', '$http', '$window', '$mdDialog', 'Announcer', 'ProvinceChooser', 'Chat', 'PATH', 'THEME', function(
            $log,
            $rootScope,
            $scope,
            $timeout,
            $state,
            $http,
            $window,
            $mdDialog,
            Announcer,
            ProvinceChooser,
            Chat,
            PATH,
            THEME
        ) {
            ContactDialogController.$inject = ['$scope', '$mdDialog', '$injector'];
            var announcer = Announcer.create($scope);

            $timeout(function() {
                announcer.emit(Announcer.types.CHANGE_THEME_COLOR, THEME.themeColor);
            });

            $rootScope.actions = {
                hideFabAction: false,
                hideFabActionMobile: false,
                hideNavigationMenu: false,
                transparentToolbar: false
            };
            var vm = this;
            announcer.on(Announcer.types.FULL_SCREEN_MODE, function(ev, mode) {
                vm.hideFooter = mode === false ? false : true;
            });
            vm.year = new Date().getFullYear();
            vm.timestamp = new Date().getTime();

            vm.openContactDialog = function openContactDialog() {
                $mdDialog.show({
                    controller: ContactDialogController,
                    templateUrl: 'main/contact-form.tpl.html',
                    clickOutsideToClose: false,
                });
            };

            $scope.$on('emarket.open-contact-dialog', vm.openContactDialog);

            var toggleStateAction = function(actions) {
                Object.keys($rootScope.actions).forEach(function(key) {
                    if (actions[key]) {
                        $rootScope.actions[key] = true;
                    } else {
                        $rootScope.actions[key] = false;
                    }
                });
            };
            var stateChangeAction = function(toState) {
                if (toState.data) {
                    toggleStateAction(toState.data);
                } else {
                    Object.keys($rootScope.actions).forEach(function(key) {
                        $rootScope.actions[key] = false;
                    });
                }
            };
            stateChangeAction($state.current);
            var event = $rootScope.$on('$stateChangeSuccess', function(event,
                toState) {
                if (toState.name !== 'main.post.search.detail') {
                    $window.scrollTo(0, 0);
                }
                stateChangeAction(toState);
                vm.hideFooter = false;
            });
            $scope.$on('$destroy', function() {
                event();
            });

            function ContactDialogController($scope, $mdDialog, $injector) {
                var $mdToast = $injector.get('$mdToast');
                $scope.form = {};

                $scope.cancel = function () {
                    $mdDialog.cancel();
                };

                $scope.send = function () {
                    grecaptcha.ready(function () {
                        grecaptcha.execute('6LesNpYaAAAAAB0hZGLrOQfoVH3wWPg4ytvos0MW', {
                            action: 'submit',
                        })
                        .then(function (token) {
                            $scope.form.token = token;
                            return $http.post(
                                PATH.api + '/contact',
                                $scope.form
                            );
                        })
                        .then(function (response) {
                            if (response && response.data && response.data.success) {
                                $mdDialog.hide();
                            } else {
                                var message = 'La información no pudo ser enviada, '
                                    + 'intenta más tarde o contacta con un administrador';
                                $mdToast.show(
                                    $mdToast
                                        .simple()
                                        .textContent(message)
                                        .hideDelay(5000)
                                );
                            }
                        });
                    });
                };
            }
        }]);
}());
